import gql from 'graphql-tag';
import { Trend360FullFragment } from '../fragments/Trend360FullFragment';

/**
 * Dettaglio Trend360.
 *
 * IMPORTANT - le liste Relation360_* sono caricate ognuna da una PROPRIA radice
 * `node(id:)` aliasata invece che come selezioni sorelle di `entity`: join-monster
 * compila ogni radice in una query SQL separata. Selezioni sorelle di piu' liste
 * 1-N nello stesso albero produrrebbero un'unica SELECT con JOIN "sorelle" il cui
 * numero di righe e' il PRODOTTO delle cardinalita' delle liste.
 */
export const Trend360DetailQuery = gql`
	query Trend360DetailQuery($id: ID!) {
		entity: node(id: $id) {
			...Trend360FullFragment
		}
		relCompany360s: node(id: $id) {
			id
			... on Trend360 {
				Relation360_Company360s {
					id
					localId
					companyLevel
					Company {
						id
						name
					}
					Brand {
						id
						name
					}
					Retailer {
						id
						name
					}
					FoodService {
						id
						name
					}
					Service {
						id
						name
					}
				}
			}
		}
		relGood360s: node(id: $id) {
			id
			... on Trend360 {
				Relation360_Good360s {
					id
					localId
					Good {
						id
						name
					}
				}
			}
		}
		relEditorialSections: node(id: $id) {
			id
			... on Trend360 {
				Relation360_EditorialSections {
					id
					localId
					name
				}
			}
		}
		relTrend360s: node(id: $id) {
			id
			... on Trend360 {
				Relation360_Trend360s {
					id
					localId
					trendName
				}
			}
		}
		relMagazines: node(id: $id) {
			id
			... on Trend360 {
				Relation360_Magazines {
					id
					localId
					name
				}
			}
		}
		relNewsletterIssues: node(id: $id) {
			id
			... on Trend360 {
				Relation360_NewsletterIssues {
					id
					localId
					Newsletter {
						id
						name
					}
				}
			}
		}
		relAdvs: node(id: $id) {
			id
			... on Trend360 {
				Relation360_Advs {
					id
					localId
					title
				}
			}
		}
		relAwards: node(id: $id) {
			id
			... on Trend360 {
				Relation360_Awards {
					id
					localId
					name
					edition
					year
				}
			}
		}
	}
	${Trend360FullFragment}
`;
